import { getDefaultViewport } from "component/molecules/viewport/ViewportConfig.js";
let enabledElements = [];

export function getAllElements() {
  let elements = [];
  for (let i = 0; i < enabledElements.length; i++) {
    elements.push(enabledElements[i].element);
  }
  return elements;
}

export function hasEnabledElement(element) {
  if (element === undefined) {
    throw new Error(
      "getEnabledElement: parameter element must not be undefined"
    );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === element) {
      return true;
    }
  }
  return false;
}

/**
 * Retrieves a  Enabled Element object
 *
 * @param {HTMLElement} element An HTML Element enabled for
 *
 * @returns {EnabledElement} A  Enabled Element
 * @memberof EnabledElements
 */
export function getEnabledElement(element) {
  if (element === undefined) {
    return false;
    // throw new Error(
    //   "getEnabledElement: parameter element must not be undefined"
    // );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === element) {
      return enabledElements[i];
    }
  }

  return true;
  //throw new Error("element not enabled");
}

export function clearEnabledElement(element) {
  if (element === undefined) {
    return false;
    // throw new Error(
    //   "getEnabledElement: parameter element must not be undefined"
    // );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === element) {
      enabledElements[i].renderingTools = {};
      enabledElements[i].data = {};
      enabledElements[i].options = null;
      enabledElements[i].viewport = getDefaultViewport(null, undefined);
      enabledElements[i].image = null;
      enabledElements[i].needsRedraw = true;
    }
  }
  return true;
}

/**
 * @todo id -> index 로 사용하지 않도록 수정해야됨
 * @param {*} id
 */
export function getEnabledElementById(id) {
  return enabledElements[id];
  // for (let i = 0; i < enabledElements.length; i++) {
  //   if (enabledElements[i].identifier === id) {
  //     return enabledElements[i];
  //   }
  // }
}

export function updateEnabledElement(elementStub) {
  if (elementStub.element === undefined) {
    throw new Error(
      "getEnabledElement: parameter element must not be undefined"
    );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === elementStub.element) {
      enabledElements[i] = elementStub;
    }
  }
}

export function redrawAllEnabledElement() {
  for (let i = 0; i < enabledElements.length; i++) {
    return (enabledElements[i].needsRedraw = true);
  }
}

export function setEnabledElement(element, elementStub) {
  if (element === undefined) {
    throw new Error(
      "getEnabledElement: parameter element must not be undefined"
    );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === element) {
      enabledElements[i] = elementStub;
    }
  }

  throw new Error("element not enabled");
}

/**
 * Adds a  Enabled Element object to the central store of enabledElements
 *
 * @param {EnabledElement} enabledElement A  enabledElement Object
 * @returns {void}
 * @memberof EnabledElements
 */
export function addEnabledElement(enabledElement) {
  if (enabledElement === undefined) {
    throw new Error(
      "getEnabledElement: enabledElement element must not be undefined"
    );
  }

  enabledElements.push(enabledElement);
}

export function removeEnabledElement(element) {
  if (element === undefined) {
    return false;
  }

  let enabledElement = getEnabledElement(element);
  if (enabledElement === false) {
    return;
  }

  let foundIdx = -1;
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === enabledElement.element) {
      foundIdx = i;
      break;
    }
  }

  if (foundIdx !== -1) {
    enabledElements.splice(foundIdx, 1);
  }
  return true;
}

/**
 * Adds a  Enabled Element object to the central store of enabledElements
 *
 * @param {string} imageId A  Image ID
 * @returns {EnabledElement[]} An Array of  enabledElement Objects
 * @memberof EnabledElements
 */
export function getEnabledElementsByImageId(imageId) {
  const ees = [];

  enabledElements.forEach(function (enabledElement) {
    if (enabledElement.image && enabledElement.image.imageId === imageId) {
      ees.push(enabledElement);
    }
  });

  return ees;
}

/**
 * Retrieve all of the currently enabled  elements
 *
 * @return {EnabledElement[]} An Array of  enabledElement Objects
 * @memberof EnabledElements
 */
export function getEnabledElements() {
  return enabledElements;
}

/**
 * Clear all of the currently enabled elements
 *
 * @memberof EnabledElements
 */
export function clearAllImage() {
  for (let i = 0; i < enabledElements.length; i++) {
    enabledElements[i].imageIdx = 0;
    enabledElements[i].image = null;
  }
}
